import axios from 'axios'

const codexMegas = axios.create({
  baseURL: process.env.CODEX_MEGAS_BASE
})

// Strip any inherited global headers (x-ss-api-key, x-ss-token)
// before every request — codex-megas doesn't need auth headers
// and they cause CORS preflight failures.
codexMegas.interceptors.request.use((config) => {
  delete config.headers['x-ss-api-key']
  delete config.headers['x-ss-token']
  return config
})

export default codexMegas
